module.exports = __webpack_public_path__ + "img/82.21a3ce6c.jpg";